import React from "react";

import {
    CURTAIN_DURATION_MS,
    CURTAIN_DURATION_REDUCED_MS,
    CURTAIN_EASE,
    CURTAIN_VELVET,
    STAGE_CREAM,
    STAGE_GOLD,
    STAGE_MUTED,
    STAGE_ROOM_IMG
} from "./stageTokens";

/** 14 bóng đèn chạy quanh viền tấm biển: 7 ngang, 7 dọc. */
function MarqueeBulbs() {
    return (
        <div
            aria-hidden
            style={{
                pointerEvents: "none",
                position: "absolute",
                inset: -1,
                borderRadius: 16
            }}
        >
            {Array.from({ length: 14 }).map((_, i) => {
                const horizontal = i < 7;
                const offset = `${Math.round((100 * (i % 7)) / 6)}%`;
                const pos = horizontal
                    ? {
                          left: offset,
                          top: i < 4 ? -3 : undefined,
                          bottom: i >= 4 && i < 7 ? -3 : undefined
                      }
                    : {
                          top: offset,
                          left: i < 11 ? -3 : undefined,
                          right: i >= 11 ? -3 : undefined
                      };
                return (
                    <span
                        key={i}
                        className="ac-bulb"
                        style={{
                            position: "absolute",
                            ...pos,
                            width: 5,
                            height: 5,
                            borderRadius: "50%",
                            background: STAGE_GOLD,
                            boxShadow: `0 0 6px ${STAGE_GOLD}`,
                            animationDelay: `${(i % 4) * 0.2}s`
                        }}
                    />
                );
            })}
        </div>
    );
}

/** Rèm nhung đóng: mái rèm, hai tấm rèm và tấm biển mời chạm để mở. */
export function CurtainCover({ open, title, receiver, onOpen, reduced, copy }) {
    const travel = `transform ${
        reduced ? CURTAIN_DURATION_REDUCED_MS : CURTAIN_DURATION_MS
    }ms ${CURTAIN_EASE}`;

    return (
        <div
            style={{
                position: "absolute",
                inset: 0,
                zIndex: 40,
                pointerEvents: open ? "none" : "auto"
            }}
        >
            {/* Mái rèm — nhấc ra khỏi khung */}
            <div
                style={{
                    position: "absolute",
                    left: 0,
                    right: 0,
                    top: 0,
                    zIndex: 10,
                    height: 64,
                    background: CURTAIN_VELVET,
                    boxShadow: "0 8px 20px rgba(0,0,0,0.5)",
                    transform: open ? "translateY(-70px)" : "translateY(0)",
                    transition: travel
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        left: 0,
                        right: 0,
                        bottom: 0,
                        height: 12,
                        background:
                            `repeating-linear-gradient(90deg, ${STAGE_GOLD} 0 6px, transparent 6px 14px)`,
                        opacity: 0.7
                    }}
                />
            </div>

            {/* Tấm rèm trái */}
            <div
                style={{
                    position: "absolute",
                    top: 0,
                    bottom: 0,
                    left: 0,
                    width: "53%",
                    background: CURTAIN_VELVET,
                    boxShadow:
                        "inset -28px 0 40px rgba(0,0,0,0.5), 4px 0 18px rgba(0,0,0,0.4)",
                    transform: open ? "translateX(-104%)" : "translateX(0%)",
                    transition: travel
                }}
            />
            {/* Tấm rèm phải */}
            <div
                style={{
                    position: "absolute",
                    top: 0,
                    bottom: 0,
                    right: 0,
                    width: "53%",
                    background: CURTAIN_VELVET,
                    boxShadow:
                        "inset 28px 0 40px rgba(0,0,0,0.5), -4px 0 18px rgba(0,0,0,0.4)",
                    transform: open ? "translateX(104%)" : "translateX(0%)",
                    transition: travel
                }}
            />

            {/* Tấm biển + nút mở rèm */}
            <div
                className={open ? "ac-cover-out" : "ac-cover-in"}
                style={{
                    position: "absolute",
                    inset: 0,
                    zIndex: 20,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "0 24px",
                    textAlign: "center"
                }}
            >
                <div
                    style={{
                        position: "relative",
                        borderRadius: 16,
                        padding: "20px 28px",
                        background: "rgba(20,8,12,0.62)",
                        border:
                            `2px solid color-mix(in srgb, ${STAGE_GOLD} 70%, transparent)`,
                        boxShadow:
                            "0 0 0 4px rgba(20,8,12,0.5), 0 18px 40px rgba(0,0,0,0.5), inset 0 0 24px rgba(244,213,138,0.18)"
                    }}
                >
                    <MarqueeBulbs />

                    {/* Ảnh quầy chụp treo như tấm hình trang trí trên biển */}
                    <div
                        style={{
                            margin: "0 auto 14px",
                            width: "min(180px, 46vw)",
                            borderRadius: 12,
                            padding: 5,
                            background:
                                `linear-gradient(160deg, ${STAGE_GOLD}, #b8894a)`,
                            boxShadow:
                                "0 12px 26px rgba(0,0,0,0.5), 0 0 22px rgba(244,213,138,0.35)"
                        }}
                    >
                        <img
                            src={STAGE_ROOM_IMG}
                            alt="Quầy chụp ảnh"
                            style={{
                                display: "block",
                                width: "100%",
                                aspectRatio: "3 / 4",
                                objectFit: "cover",
                                borderRadius: 8
                            }}
                        />
                    </div>

                    <p
                        style={{
                            margin: 0,
                            fontSize: 11,
                            fontWeight: 600,
                            textTransform: "uppercase",
                            letterSpacing: "0.3em",
                            color: STAGE_GOLD
                        }}
                    >
                        {copy.specialShow}
                    </p>
                    <h1
                        style={{
                            margin: "8px 0 0",
                            maxWidth: "16rem",
                            fontSize: "clamp(2rem, 8.5vw, 3rem)",
                            fontWeight: 700,
                            lineHeight: 0.98,
                            fontFamily: "Broline, cursive",
                            color: STAGE_CREAM,
                            textShadow: "0 0 18px rgba(244,213,138,0.5)"
                        }}
                    >
                        {title}
                    </h1>
                    <p style={{ margin: "8px 0 0", fontSize: 14, color: STAGE_MUTED }}>
                        {copy.forRecipient(receiver)}
                    </p>
                </div>

                <div
                    className={reduced ? undefined : "ac-float"}
                    style={{ position: "relative", zIndex: 10, marginTop: 32 }}
                >
                    <button
                        type="button"
                        onClick={onOpen}
                        className="ac-cta"
                        style={{
                            borderRadius: 999,
                            border: "none",
                            padding: "12px 32px",
                            fontSize: 14,
                            fontWeight: 700,
                            cursor: "pointer",
                            background: STAGE_GOLD,
                            color: "#3a1410",
                            boxShadow: "0 12px 30px rgba(244,213,138,0.4)"
                        }}
                    >
                        {copy.openCurtain}
                    </button>
                </div>

                <p style={{ margin: "12px 0 0", fontSize: 12, color: STAGE_MUTED }}>
                    {copy.curtainHint}
                </p>
            </div>
        </div>
    );
}
